import React, { useEffect, useState } from "react";
import Header from "../../components/Partials/Header";
import MapFooter from "../../components/Partials/MapFooter";
import DefaultLayout from "../../components/Layout/DefaultLayout";
import { translate } from "../../assets/js/functions";

import { domain, getTypologies, getAllMapsMarks } from "../../assets/js/api";
import { Link } from "react-router-dom";
import proj4 from "proj4";

export default function Map(props) {
  const [data, setData] = useState(null);
  const [typologies, setTypologies] = useState(null);
  const [layersMap, setLayersMap] = useState(null);
  const [showAllData, setShowAllData] = useState(true);
  let [map, setMap] = useState(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://sitna.tracasa.es/api/";
    script.async = true;
    script.onload = () => scriptLoaded();

    document.body.appendChild(script);
  }, []);



  async function scriptLoaded() {
    getTypologies().then((typologies) => {
      setTypologies(typologies);
    });

    var SITNA = window.SITNA;

    proj4.defs(
      "EPSG:25830",
      "+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs"
    );
    proj4.defs("EPSG:4326", "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs");

    map = new SITNA.Map("mapa", {
      baseLayers: [SITNA.Consts.layer.IDENA_DYNBASEMAP],
      defaultBaseLayer: SITNA.Consts.layer.IDENA_DYNBASEMAP,
      controls: {
        overviewMap: {
          layer: SITNA.Consts.layer.IDENA_DYNBASEMAP,
        },
      },
    });

    const layersMap = await getAllMapsMarks();

    if (layersMap) {
      const promises = layersMap.map((element) =>
        new Promise((resolve) => {
          map.loaded(() => {
            map.addLayer(element.layer, () => resolve());
          });
        })
      );
      await Promise.all(promises);
    }

    setLayersMap(layersMap);
    setMap(map);
  }

  function updateMapByTipology(typology) {
    let toggleVisibilityPromise = Promise.resolve();
    if (showAllData) {
      toggleVisibilityPromise = new Promise((resolve) => {
        toggleVisibility();
        resolve();
      });
    }

    toggleVisibilityPromise.then(() => {
      try {
        const indexObject = layersMap.findIndex(
          (object) => object.typologyData === typology
        );
        if (indexObject !== -1) {
          const indexLayer = map.layers.findIndex(
            (object) => object.id === layersMap[indexObject].layer.id
          );

          if (indexLayer !== -1) {
            map.layers[indexLayer].setVisibility(
              !map.layers[indexLayer].getVisibility()
            );
          }
          const checkbox = document.getElementById(
            `typology_checkbox_${typology}`
          );
          if (checkbox) {
            checkbox.checked = !map.layers[indexLayer].getVisibility();
          }
        }
      } catch (error) {
        console.error(error);
      }
    });
  }

  function toggleVisibility() {
    try {
      layersMap.forEach((object) => {
        const indexLayer = map.layers.findIndex(
          (layer) => layer.id === object.layer.id
        );
        if (indexLayer !== -1) {
          if (showAllData) {
            map.layers[indexLayer].setVisibility(false);
          } else {
            map.layers[indexLayer].setVisibility(true);
          }
        }

        const checkboxes = document.querySelectorAll(".checkbox_typology");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
      });

      setShowAllData(!showAllData);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <DefaultLayout pageMeta={{}}>
      <Header />
      <main className="main-content h-100 mapa" id="main">
        <div className="map-container wrapper">
          <div className="columns is-widescreen mb-0">
            <div className="column is-4-desktop is-3-fullhd"></div>
            <div className="column">
              <h2 className="bordered-title is-size-1 has-text-weight-bold">
                {translate("Mapa del Censo de Simbología Franquista Retirada")}
              </h2>
            </div>
          </div>
          <div className="columns is-widescreen is-flex-direction-row-reverse">
            <div className="column">
              <div className="map" id="mapa"></div>
            </div>
            <div className="column is-4-desktop is-3-fullhd flow">
              <Link
                to=""
                className="check-map"
                onClick={(event) => {
                  event.preventDefault();
                  toggleVisibility();
                }}
              >
                <input
                  className="is-checkradio "
                  type="checkbox"
                  checked={showAllData}
                  onChange={() => {
                    toggleVisibility();
                  }}
                />
                <label>{translate("Ver todos los resultados")}</label>
              </Link>
              <h3 className="has-text-weight-bold is-size-5">
                {translate("Filtrar por tipología")}
              </h3>
              <ul className="flow--3xs link-dn">
                {typologies
                  ? typologies.map((res) => (
                      <li key={res.typology_data}>
                        <Link
                          to=""
                          onClick={(event) => {
                            event.preventDefault();
                            updateMapByTipology(res.typology_data);
                          }}
                        >
                          <input
                            className="is-checkradio checkbox_typology"
                            type="checkbox"
                            id={"typology_checkbox_" + res.typology_data}
                          />
                          <label>{res.typology}</label>
                        </Link>
                      </li>
                    ))
                  : ""}
              </ul>
            </div>
          </div>
        </div>
      </main>
      <MapFooter />
    </DefaultLayout>
  );
}
